import React from "react";
import "./App.css";

function Dec() {

    return (
        <div className="dec-container">
            <div className="dec">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="gradient-container">
                <div className="block"></div>
                <div className="gradient"></div>
            </div>
        </div>
    );
}

export default Dec;
